"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAPICallRepetitionFromError = void 0;
var _errorSelectors = require("../../store/error/errorSelectors");
var _errorActions = require("../../store/error/errorActions");
var _react = require("react");
var _services = require("../../services");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
var _logger = require("../../services/logger");
const useAPICallRepetitionFromError = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const currentErrorMessage = _services.Services.locale.localeString('ErrorPage.Message', {
    defaultValue: '',
    allowMissingKey: true
  });
  const stateErrorMessage = (0, _useAppSelector.useAppSelector)(_errorSelectors.selectErrorMessage);
  const errorMessage = currentErrorMessage || stateErrorMessage;
  const previousAction = (0, _useAppSelector.useAppSelector)(_errorSelectors.selectPreviousAPICallAction);
  const callIsInProgress = (0, _useAppSelector.useAppSelector)(_errorSelectors.selectIsInProgress);
  const hasError = (0, _useAppSelector.useAppSelector)(_errorSelectors.selectHasError);
  const pageToReturnTo = (0, _useAppSelector.useAppSelector)(_errorSelectors.selectPageToReturnTo);
  const retryAPICall = () => {
    dispatch((0, _errorActions.setRetryInProgress)());
    dispatch(previousAction);
  };
  (0, _react.useEffect)(() => {
    if (!callIsInProgress && !hasError) {
      _logger.Logger.info({
        segments: [_logger.Logger.LOGGER_SEGMENTS.QUESTIONNAIRE, _logger.Logger.LOGGER_SEGMENTS.HOOKS]
      })('Change Page');
      dispatch((0, _errorActions.setApiCallRetrySuccess)(pageToReturnTo));
    }
  }, [callIsInProgress, hasError]);
  return {
    errorMessage,
    retryAPICall,
    callIsInProgress
  };
};
exports.useAPICallRepetitionFromError = useAPICallRepetitionFromError;